module.exports = __webpack_public_path__ + "assets/img/29_240.bbf25966.jpg";